import React, { useState, useEffect } from "react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  IconButton,
  LinearProgress,
  Link,
  Select,
  Typography,
  Alert,
  Button
} from "@mui/material";
import bkstApi from "../../common/component/api";
import currency from "currency.js";
import CloseIcon from "@mui/icons-material/Close";
import { equalsIgnoreCase } from "../../common/component/util";
import CountUp from "../../common/component/animate/CountUp";

export default function AiQuote(props) {
  const { imageSrc, bakerId, productType, productSubtype, complexity, servings } = props;
  const [open, setOpen] = useState(false);

  const [data, setData] = useState("");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    bkstApi(`/baker/${bakerId}/config/model`).then((res) => {
      setData({ [bakerId]: { model: res.data.config } });
      setLoading(false);
    });
  }, []);

  const getQuoteFromModel = (productType, productSubtype, complexity, servings) => {
    let arr = [];
    if (data[bakerId]?.model?.[productType]?.type) {
      console.log("getQuoteFromModel", bakerId, productType, productSubtype, complexity, servings);

      const sizeChart = data[bakerId]?.model?.[productType]?.type;
      console.log("sizeChart", sizeChart);
      for (const [shape, sizes] of Object.entries(sizeChart)) {
        console.log("shape", shape, sizes);
        if (productSubtype && equalsIgnoreCase(productSubtype, shape)) {
          for (const size of sizes) {
            const product = size.product;
            let productServings = product.servings;
            console.log("productServings", productServings);

            let minServings, maxServings;
            if (typeof productServings === "string" && productServings.includes("-")) {
              // Range, e.g., "34-38"
              [minServings, maxServings] = productServings.split("-").map((s) => parseInt(s.trim(), 10));
            } else {
              // Single value
              minServings = maxServings = parseInt(productServings, 10);
            }
            const servingsInt = parseInt(servings, 10);
            if ((servingsInt >= minServings && servingsInt <= maxServings) || product.servings === servings) {
              arr.push({ pricing: size.pricing.levels[complexity], product: size.product });
            }
          }
        }
      }
    }
    if (arr.length === 0) {
      // try with +2 servings
      const newServings = +servings + 2;
      if (newServings <= 100) {
        return getQuoteFromModel(productType, productSubtype, complexity, newServings);
      }
    }
    return arr;
  };

  let productTypes = [];
  for (const acctId in data) {
    const acctModel = data[acctId].model;
    if (acctModel) {
      productTypes.push(...Object.keys(acctModel));
    }
  }
  productTypes = [...new Set(productTypes)].sort();

  let productSubtypes = [];
  for (const acctId in data) {
    const acctModel = data[acctId].model;
    if (acctModel) {
      const acctModelSubtypes = acctModel[productType]?.type;
      if (acctModelSubtypes) {
        productSubtypes.push(...Object.keys(acctModelSubtypes));
      }
    }
  }
  productSubtypes = [...new Set(productSubtypes)].sort();

  return (
    <>
      <Box sx={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
        {getQuoteFromModel(productType, productSubtype, complexity, servings)?.map((o) => {
          return (
            <Box
              p={2}
              sx={{
                border: "1px solid #EEE",
                width: "300px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                flexGrow: 1,
                textAlign: "center",
                backgroundColor: "#FAFAFA"
              }}
            >
              {o.pricing?.amount && (
                <Box py={2}>
                  <Typography variant="h4" gutterBottom>
                    {currency(o.pricing?.amount, { precision: 0 }).format()}
                  </Typography>
                  <Typography variant="body2">
                    {o.product && `${o.product.frosting}, ${o.product.shape} ${o.product.size} (${o.product.servings} servings)`}
                  </Typography>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth={true} maxWidth="md">
        <DialogTitle>
          AI Quote
          <IconButton
            color="inherit"
            size="small"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8
            }}
          >
            <CloseIcon sx={{ color: "#999" }} />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {loading ? (
            <LinearProgress />
          ) : (
            <Box>
              <Box mt={2}>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <img src={imageSrc} style={{ width: "100%" }} />
                  </Grid>
                  <Grid item xs={6}></Grid>
                </Grid>
              </Box>
              {data[bakerId]?.alerts?.notes && (
                <Box my={2}>
                  <Alert severity="info">{data[bakerId]?.alerts?.notes}</Alert>
                </Box>
              )}
              <Box>
                <Box py={2} sx={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
                  {data[bakerId]?.model?.[productType]?.type?.[productSubtype]?.map((o) => {
                    return (
                      <Box
                        px={0.5}
                        sx={{
                          border: "1px solid #EEE",
                          width: "300px",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "space-between",
                          flexGrow: 1,
                          textAlign: "center",
                          backgroundColor: "#FAFAFA"
                        }}
                      >
                        <Box py={2}>
                          <Typography variant="body2">
                            {o.product && `${o.product.frosting}, ${o.product.shape} ${o.product.size} (${o.product.servings} servings)`}
                          </Typography>
                        </Box>
                        <Box sx={{ display: "flex", gap: "5px", justifyContent: "center" }}>
                          {o.pricing.levels.map((l, idx) => (
                            <Box>
                              <Link
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  //addItem(o.product, l);
                                  setOpen(false);
                                }}
                              >
                                <Chip label={idx + 1} />
                              </Link>
                              <Box>
                                <Typography variant="overline">{currency(l.amount, { precision: 0 }).format()}</Typography>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}
